import { useState } from "react";
import { Card, Typography, Select, Button, Tabs, Badge, Space, Divider } from "antd";
import { EnvironmentOutlined, VideoCameraOutlined, ClockCircleOutlined, DownOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

const timeSlots = [
  "9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM", "11:00 AM",
  "11:30 AM", "2:00 PM", "2:30 PM", "3:00 PM", "3:30 PM",
  "4:00 PM", "4:30 PM", "7:00 PM", "7:30 PM", "8:00 PM",
  "8:30 PM", "9:00 PM", "9:30 PM", "10:00 PM"
];

export function AppointmentBooking() {
  const [selectedSlot, setSelectedSlot] = useState("10:00 PM");
  const [consultationType, setConsultationType] = useState("in-clinic");
  const [showAllSlots, setShowAllSlots] = useState(false);

  const displayedSlots = showAllSlots ? timeSlots : timeSlots.slice(0, 6);

  return (
    <Card className="">
      <Title level={4} className="mb-4">Book an Appointment</Title>

      <Tabs activeKey={consultationType} onChange={setConsultationType}>
        <TabPane
          tab={
            <Space>
              <EnvironmentOutlined />
              In-clinic
            </Space>
          }
          key="in-clinic"
        >
          <div className="mb-6">
            <Text strong>Select Clinic</Text>
            <Select defaultValue="life-sarthi" className="w-full mt-2 h-14">
              <Option value="life-sarthi">
                <div>
                  Life Sarthi Multispecialty Clinic
                  <div className="text-xs text-gray-500">Sector 12, Noida, Uttar Pradesh</div>
                </div>
              </Option>
              <Option value="apollo">
                <div>
                  Apollo Clinic
                  <div className="text-xs text-gray-500">Sector 18, Noida, Uttar Pradesh</div>
                </div>
              </Option>
            </Select>
          </div>
        </TabPane>

        <TabPane
          tab={
            <Space>
              <VideoCameraOutlined />
              Teleconsultation
            </Space>
          }
          key="teleconsultation"
        >
          <div className="p-4 bg-gray-100 rounded-md">
            <Space>
              <VideoCameraOutlined />
              <Text type="secondary">Video consultation will be conducted via secure video call</Text>
            </Space>
          </div>
        </TabPane>
      </Tabs>

      <Divider className="my-6" />

      <div className="mb-6">
        <Text strong>Select Service</Text>
        <Select defaultValue="consultation" className="w-full mt-2">
          <Option value="consultation">Consultation</Option>
          <Option value="follow-up">Follow-up Visit</Option>
          <Option value="diabetes-management">Diabetes Management</Option>
        </Select>
      </div>

      <div className="mb-6">
        <Space className="w-full justify-between">
          <Text strong>Available Slots</Text>
          <Space size={4}>
            <ClockCircleOutlined />
            <Text type="secondary">Today, Dec 15</Text>
          </Space>
        </Space>

        <div className="flex flex-wrap gap-2 mt-2">
          {displayedSlots.map((slot) => (
            <Button
              key={slot}
              type={selectedSlot === slot ? "primary" : "default"}
              onClick={() => setSelectedSlot(slot)}
            >
              {slot}
            </Button>
          ))}
        </div>

        {!showAllSlots && (
          <Button
            type="link"
            icon={<DownOutlined />}
            onClick={() => setShowAllSlots(true)}
            className="w-full mt-4"
          >
            See all slots
          </Button>
        )}
      </div>

      <Divider className="my-6" />

      <div className="bg-gray-100 p-4 rounded-md">
        <Space className="w-full justify-between">
          <Text type="secondary">Selected slot:</Text>
          <Badge count={selectedSlot} className="bg-blue-500 text-white" />
        </Space>
        <Space className="w-full justify-between mt-2">
          <Text type="secondary">Consultation fee:</Text>
          <Text strong>₹500</Text>
        </Space>
      </div>

      <Button type="primary" block className="mt-6">
        Book Appointment
      </Button>
    </Card>
  );
}
